import {
  GET_METABASE_DASHBOARD,
  GET_METABASE_DASHBOARD_COMPLETED,
  GET_METABASE_DASHBOARD_FAILED,
} from "./actions";

const initialState = {
  iframeUrl: null,
  instanceUrl: null,
  theme: null,
  error: null,
  isLoading: false,
  isInitialized: false,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_METABASE_DASHBOARD:
      return { ...state, isLoading: true, error: null };
    case GET_METABASE_DASHBOARD_COMPLETED: {
      // L'API enveloppe la réponse dans { code, result: { success, data } }
      // (comme les endpoints bancaires) : on déballe le niveau interne.
      const p = action.payload.result || {};
      const res = p.result || p;
      const d = res.data || {};
      return {
        ...state,
        iframeUrl: d.iframeUrl || null,
        instanceUrl: d.instanceUrl || null,
        theme: d.theme || null,
        error: res.success ? null : res.message || "Erreur Metabase",
        isLoading: false,
        isInitialized: true,
      };
    }
    case GET_METABASE_DASHBOARD_FAILED: {
      const res = (action.payload && action.payload.result) || {};
      return {
        ...state,
        error: res.message || "Impossible de charger le dashboard Metabase.",
        isLoading: false,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
};

export default reducers;
